import { render } from "./GenderList.vue?vue&type=template&id=c785d8e6"
import script from "./GenderList.vue?vue&type=script&lang=js"
export * from "./GenderList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__